import request from '#/utils/request';

import { WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE } from './constants';
import { parseFormCacheEnvelope } from './parseEnvelope';

/**
 * DELETE /system/form-cache/{scope}?snapshot_id=
 * Exact ACTIVE snapshot discard；不可無條件刪除。
 * @param {string} snapshotId
 * @param {string} [scope]
 */
export async function discardFormCache(
  snapshotId,
  scope = WORK_ORDER_STOCK_TRANSFER_CACHE_SCOPE,
) {
  const { data: raw } = await request.delete(`/system/form-cache/${scope}`, {
    params: { snapshot_id: snapshotId },
  });
  return parseFormCacheEnvelope(raw);
}
